module.exports = __webpack_public_path__ + "static/media/check.5bf8d676.svg";